// extracted by mini-css-extract-plugin
export var standaloneTable = "_hm-0";
export var standaloneTableWithBodyFill = "_hm-1";
export var withExtraHeader = "_hm-2";